module.exports = __webpack_public_path__ + "img/icon-year.b5b867e4.svg";